export default __webpack_public_path__ + "static/media/ban-desktop-image-6.50a89ba1.jpg";